module.exports = __webpack_public_path__ + "static/media/blockTribune.8f98ac0c.png";